import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

function useCancelClass() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (attendanceId) => {
      const res = await apiClient.delete(`/api/v1/attendances/${attendanceId}/`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["student", "my-classes"] });
      queryClient.invalidateQueries({ queryKey: ["student", "balance"] });
      queryClient.invalidateQueries({ queryKey: ["student", "calendar"] });
    },
  });
}

export { useCancelClass };
